export default __webpack_public_path__ + "static/media/2258.4c6a813d.png";